import { COLORS, fontFamilyFor } from "../../theme";

// Mirrors new-design's sub-page <nav> (about/pricing/how-it-works/
// contact-sales.html): logo + text nav-links (with active state) +
// single "Back to Home" pill — distinct from the homepage's nav.
export const Style = {
  spacer: { width: "100%", height: { xs: "76px", md: "108px" } },
  appBar: {
    background: "rgba(26,26,26,0.95)",
    backdropFilter: "blur(16px)",
    boxShadow: "none",
    borderBottom: "1px solid rgba(255,255,255,0.05)",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    py: { xs: "16px", md: "24px" },
    px: { xs: "16px", md: "48px" },
    minHeight: "0 !important",
  },
  logoImg: { height: { xs: "44px", md: "60px" }, width: { xs: "44px", md: "60px" }, objectFit: "contain", cursor: "pointer" },
  navLinks: (isArabic) => ({
    display: { xs: "none", md: "flex" },
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    gap: "2.2rem",
  }),
  navLink: (isArabic, active) => ({
    color: active ? COLORS.peach : "rgba(255,255,255,0.65)",
    fontWeight: active ? 600 : 500,
    fontSize: "15px",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    cursor: "pointer",
    transition: "color 0.2s ease",
    "&:hover": { color: COLORS.peach },
  }),
  backButton: (isArabic) => ({
    py: "12px",
    px: { xs: "18px", md: "32px" },
    borderRadius: "50px",
    background: COLORS.peach,
    color: COLORS.dark,
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: { xs: "13px", md: "15px" },
    fontWeight: "700",
    whiteSpace: "nowrap",
    "&:hover": { background: COLORS.gold },
  }),
};
